import { render, staticRenderFns } from "./Wenzi.vue?vue&type=template&id=2e6b3670&"
import script from "./Wenzi.vue?vue&type=script&lang=js&"
export * from "./Wenzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Wenzi.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=Yangshi.css"
if (typeof block0 === 'function') block0(component)

export default component.exports